import React, { ReactNode } from "react";
import Sidebar from "./Sidebar";
import HeaderLoggedIn from "./HeaderLoggedIn";
import "../styles/components/layout.css";
import { useAuth } from "../context/AuthContext";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  
  return (
    <div className="admin-layout">
      {isAuthenticated && <Sidebar />}
      <div className="admin-main">
        {isAuthenticated && <HeaderLoggedIn />}
        <div className="dashboard-content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
